'use strict';

import { loadCSS, loadScript } from "../boot/asset-loaders";
import InterNACHI from './InterNACHI.js';

const SELECT2_VERSION = `4.0.5`;
const INTL_TEL_INPUT_VERSION = `12.1.15`;
const FONT_AWESOME_VERSION = `4.7.0`;
const FROALA_VERSION = `3.1.0`;

const loadStyles = () => {
	loadCSS(`https://cdnjs.cloudflare.com/ajax/libs/select2/${ SELECT2_VERSION }/css/select2.min.css`, document.getElementById('common-css'));
	loadCSS(`https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/${ INTL_TEL_INPUT_VERSION }/css/intlTelInput.css`);
	loadCSS(`https://cdnjs.cloudflare.com/ajax/libs/font-awesome/${ FONT_AWESOME_VERSION }/css/font-awesome.min.css`);
	
	loadCSS(`https://cdn.jsdelivr.net/npm/froala-editor@${ FROALA_VERSION }/css/froala_editor.min.css`);
	loadCSS(`https://cdn.jsdelivr.net/npm/froala-editor@${ FROALA_VERSION }/css/froala_style.min.css`);
	loadCSS(`https://cdn.jsdelivr.net/npm/froala-editor@${ FROALA_VERSION }/css/plugins/image.min.css`);
	loadCSS(`https://cdn.jsdelivr.net/npm/froala-editor@${ FROALA_VERSION }/css/plugins/video.min.css`);
	loadCSS(`https://cdn.jsdelivr.net/npm/froala-editor@${ FROALA_VERSION }/css/plugins/code_view.min.css`);
	loadCSS(`https://cdn.jsdelivr.net/npm/froala-editor@${ FROALA_VERSION }/css/plugins/draggable.min.css`);
	loadCSS(`https://cdn.jsdelivr.net/npm/froala-editor@${ FROALA_VERSION }/css/plugins/image.min.css`);
	loadCSS(`https://cdn.jsdelivr.net/npm/froala-editor@${ FROALA_VERSION }/css/plugins/table.min.css`);
	loadCSS(`https://cdn.jsdelivr.net/npm/froala-editor@${ FROALA_VERSION }/css/plugins/quick_insert.min.css`);
	
	// loadCSS('https://unpkg.com/filepond/dist/filepond.css');
	// loadCSS('https://unpkg.com/filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css');
};

const select2 = () => import('select2' /* webpackChunkName: "achunk~select2" */).then(() => {
	// TODO: Tailwind theme for select2
	window.jQuery.fn.select2.defaults.set("theme", "bootstrap");
	console.log('select2 loaded');
});

const intlTelInput = () => import('intl-tel-input' /* webpackChunkName: "achunk~intl-tel-input" */).then(() => {
	const utils = `https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/${ INTL_TEL_INPUT_VERSION }/js/utils.js`;
	window.jQuery.fn.intlTelInput.loadUtils(utils);
	console.log('intl-tel-input loaded');
});

const validation = () => import('./validation/plugin.js' /* webpackChunkName: "achunk~validation-plugin" */).then(plugin => {
	window.jQuery.fn.clientValidation = plugin.default;
	// Allow for hot module replacement
	if (module.hot) {
		module.hot.accept('./validation/plugin.js', () => {
			window.jQuery.fn.clientValidation = require('./validation/plugin.js').default;
		});
	}
	console.log('Validation plugin loaded');
});

// TODO: Not yet in use and breaks the webpack build right now
// const filepond = () => Promise.all([
// 	import('filepond' /* webpackChunkName: "achunk~filepond-core" */),
// 	import('filepond-plugin-image-preview' /* webpackChunkName: "achunk~filepond-plugin-image-preview" */),
// 	import('filepond-plugin-file-validate-type' /* webpackChunkName: "achunk~filepond-plugin-file-validate-type" */),
// 	import('filepond-plugin-file-encode' /* webpackChunkName: "achunk~filepond-plugin-file-encode" */),
// ]).then(([FilePond, PreviewPlugin, ValidationPlugin, EncodePlugin]) => {
// 	FilePond.registerPlugin(PreviewPlugin);
// 	FilePond.registerPlugin(ValidationPlugin);
// 	FilePond.registerPlugin(EncodePlugin);
// 	window.FilePond = FilePond;
// 	console.log('Filepond loaded');
// });

const froalaBase = `https://cdn.jsdelivr.net/npm/froala-editor@${ FROALA_VERSION }`;

const froala = () => loadScript(`${ froalaBase }/js/froala_editor.min.js`)
	.then(() => Promise.all([
		loadScript(`${ froalaBase }/js/plugins/align.min.js`),
		loadScript(`${ froalaBase }/js/plugins/link.min.js`),
		loadScript(`${ froalaBase }/js/plugins/lists.min.js`),
		loadScript(`${ froalaBase }/js/plugins/image.min.js`),
		loadScript(`${ froalaBase }/js/plugins/file.min.js`),
		loadScript(`${ froalaBase }/js/plugins/video.min.js`),
		loadScript(`${ froalaBase }/js/plugins/table.min.js`),
		loadScript(`${ froalaBase }/js/plugins/code_beautifier.min.js`),
		loadScript(`${ froalaBase }/js/plugins/code_view.min.js`),
		loadScript(`${ froalaBase }/js/plugins/draggable.min.js`),
		loadScript(`${ froalaBase }/js/plugins/entities.min.js`),
		loadScript(`${ froalaBase }/js/plugins/lists.min.js`),
		loadScript(`${ froalaBase }/js/plugins/quick_insert.min.js`),
		loadScript(`${ froalaBase }/js/plugins/word_paste.min.js`),
		loadScript(`${ froalaBase }/js/plugins/url.min.js`),
		loadScript(`${ froalaBase }/js/plugins/paragraph_format.min.js`),
	]))
	.then(() => {
		window.FroalaEditor.VIDEO_PROVIDERS.push({
			provider: 'wistia',
			test_regex: /^.*wistia.com\/medias\/.*/,
			url_regex: /^.*wistia.com\/medias\/(.*)$/,
			url_text: '$1',
			html: `<div class="wistia_responsive_padding" style="padding:74.06% 0 0 0;position:relative;">
				<div class="wistia_responsive_wrapper" style="height:100%;left:0;position:absolute;top:0;width:100%;">
					<iframe src="https://fast.wistia.net/embed/iframe/{url}?seo=false&videoFoam=true" allowtransparency="true" frameborder="0" scrolling="no" class="wistia_embed" name="wistia_embed" allowfullscreen mozallowfullscreen webkitallowfullscreen oallowfullscreen msallowfullscreen width="100%" height="100%"></iframe>
				</div>
			</div>`,
		});
		
		InterNACHI.helpers.createFroalaInstance = (target, options) => {
			return new FroalaEditor(target, {
				linkList: [],
				linkStyles: {
					'btn': 'Button',
					'btn btn-blue': 'Blue Button',
					'btn btn-red': 'Red Button',
				},
				attribution: false,
				...options,
				key: window.froalaKey,
			});
		};
		
		console.log('Froala loaded.');
	});

export default function() {
	loadStyles();
	return Promise.all([
		select2(),
		intlTelInput(),
		validation(),
		// filepond(),
		froala(),
	]);
}
